<div
  class="w-full rounded-2xl border border-soft-gray-outline overflow-hidden"
  [ngClass]="
    enableInternalScroll
      ? 'flex flex-col h-full'
      : 'overflow-x-auto scroll-custom'
  "
  #tableContainer
  (scroll)="onTableScroll()"
>
  <table
    class="min-w-full"
    [ngClass]="enableInternalScroll ? 'flex flex-col h-full' : ''"
  >
    <thead
      [ngClass]="(enableInternalScroll ? 'block ' : '') + 'bg-light border-b border-soft-gray-outline ' + effectiveTheadHeight"
      [ngStyle]="headerStyle"
    >
      <tr [ngClass]="enableInternalScroll ? 'table w-full table-fixed' : ''">
        @for (col of columns; track $index) {
        <th
          scope="col"
          [ngClass]="
            col.headerClass
              ? col.headerClass
              : $index === 0
              ? 'px-6 py-3 font-semibold text-[14px] select-none whitespace-nowrap overflow-hidden text-ellipsis min-w-[100px] ' + defaultHeaderTextClass
              : 'px-6 py-3 font-semibold text-[14px] select-none whitespace-nowrap overflow-hidden text-ellipsis min-w-[150px] max-w-[150px] ' + defaultHeaderTextClass
          "
          [ngStyle]="headerTextStyle"
        >
          <div
            class="flex items-center"
            [ngClass]="{
              'justify-between': showHeaderFilter && !col.sortable,
              'space-x-1': !showHeaderFilter || col.sortable
            }"
          >
            <span class="truncate block" appTruncateTooltip>{{ col.label }}</span>

            @if (col.sortable && showSorting) {
            <div
              class="flex flex-col leading-none cursor-pointer p-1 rounded hover:bg-gray-100 transition-colors"
              (click)="onSortToggle(col.key)"
              title="Ordenar por {{ col.label }}"
            >
              <i
                class="fi-sr-caret-up text-[10px] -mb-[3px]"
                [ngClass]="{
                  'text-text-primary':
                    sortColumn() === col.key && sortDirection() === 'asc',
                  'text-text-secondary':
                    sortColumn() !== col.key || sortDirection() !== 'asc'
                }"
              ></i>
              <i
                class="fi-sr-caret-down text-[10px] -mt-[4px]"
                [ngClass]="{
                  'text-text-primary':
                    sortColumn() === col.key && sortDirection() === 'desc',
                  'text-text-secondary':
                    sortColumn() !== col.key || sortDirection() !== 'desc'
                }"
              ></i>
            </div>
            } @if (showHeaderFilter && !col.sortable) {
            <multiselect-table
              [options]="getFilterOptions(col.key)"
              placeholder="Seleccione una opción"
              (optionsSelectedChange)="onFilterChange(col.key, $event)"
            >
            </multiselect-table>
            }
          </div>
        </th>
        } @if (icon1 || icon2 || showToggle) {
        <th
          [ngClass]="effectiveActionColumnClass || 'px-4 py-2 font-semibold text-[14px] text-text-primary whitespace-nowrap select-none sticky right-0 bg-light z-20'"
          [class.shadow-left]="showColumnShadow"
        >
          <span [ngClass]="tableConfig?.toggleTextClass || styleConfig?.toggleTextClass || ''">{{ toggleText }}</span>
        </th>
        }
      </tr>
    </thead>
    <tbody
      [ngClass]="enableInternalScroll ? 'block overflow-y-auto flex-1' : ''"
      [style.max-height]="enableInternalScroll ? '100%' : 'auto'"
    >
      @if (paginatedData.length > 0) { @for (row of paginatedData; track row.id
      || $index; let i = $index) {
      <tr
        [ngClass]="[
          enableInternalScroll ? 'table w-full table-fixed' : '',
          'whitespace-nowrap odd:bg-stepper-active-num even:bg-light hover:bg-[#E1E5FF] group',
          effectiveRowHeight,
          row.visible === false ? 'opacity-60 text-[#9DA0A8]' : '',
          getRowCursorStyle()
        ]"
        [ngStyle]="zebraStyle && i % 2 === 1 ? zebraStyle : null"
        (click)="onRowClick(row, $event)"
      >
        @for (col of columns; track col.key; let j = $index) {
        <td
          [ngClass]="[
            col.cellClass
              ? col.cellClass
              : j === 0
              ? isFirstColumnDark
                ? 'px-6 py-2 overflow-hidden text-ellipsis whitespace-nowrap min-w-[100px] font-medium text-[14px]'
                : 'px-6 py-2 overflow-hidden text-ellipsis whitespace-nowrap min-w-[100px] font-normal text-[12px]'
              : 'px-6 py-2 overflow-hidden text-ellipsis whitespace-nowrap min-w-[150px] max-w-[150px] font-normal text-[12px]',
            row.visible === false ? 'text-[#9DA0A8]' : 'text-text-primary'
          ]"
        >
          @if (j === 0 && row.visible === false) {
          <i class="fi-rr-eye-crossed text-[#9DA0A8] text-sm mr-2 align-middle" title="Oculto"></i>
          }
          @switch (col.type) { @case ('chip') {
          <span
            class="px-3 py-1 rounded-full text-xs font-medium truncate"
            [ngClass]="{
              'bg-chip-green text-text-primary': [
                'activo',
                'en uso',
                'aprobada'
              ].includes(row[col.key].toLowerCase()),
              'bg-chip-red text-text-primary': [
                'inactivo',
                'rechazada'
              ].includes(row[col.key].toLowerCase()),
              'bg-chip-yellow text-text-primary': [
                'pendiente',
                'sin uso',
                'desistida'
              ].includes(row[col.key].toLowerCase()),
              'bg-secundary-b1200 text-text-primary': [
                'borrador',
                'test',
                'en curso'
              ].includes(row[col.key].toLowerCase())
            }"
            appTruncateTooltip
          >
            {{ row[col.key] }}
          </span>
          } @case ('code') {
          <span
            class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-[#C0D3F9] text-text-primary truncate"
            appTruncateTooltip
          >
            {{ row[col.key] }}
          </span>
          } @case ('card') {
          <div class="flex items-center gap-2 min-w-0">
            <img
              [src]="row[col.key]?.foto"
              alt="foto"
              class="w-8 h-8 rounded-full object-cover flex-shrink-0"
            />
            <span class="text-sm font-medium text-text-primary truncate" appTruncateTooltip>
              {{ row[col.key]?.nombre }}
            </span>
          </div>
          } @case ('check') {
          <div class="flex items-center">
            <input
              type="radio"
              name="radio-{{ col.key }}"
              class="h-4 w-4 rounded-full cursor-pointer appearance-none border border-gray checked:bg-stepper-active-num checked:border-green-600 checked:border-4 focus:outline-none focus:ring-0"
              [checked]="row[col.key]"
              (change)="toggleRow(row)"
            />
          </div>
          } @case ('circle') {
          <div
            class="w-4 h-4 rounded-full"
            [ngClass]="{
              'bg-success': row[col.key].toLowerCase() === 'success',
              'bg-error': row[col.key].toLowerCase() === 'error',
              'bg-warning': row[col.key].toLowerCase() === 'warning'
            }"
          ></div>
          } @case ('circleWithText') {
          <div class="flex items-center gap-2">
            <span
              class="w-4 h-4 rounded-full flex-shrink-0"
              [ngClass]="{
                'bg-success': row[col.key]?.color?.toLowerCase() === 'success',
                'bg-error': row[col.key]?.color?.toLowerCase() === 'error',
                'bg-warning': row[col.key]?.color?.toLowerCase() === 'warning'
              }"
              aria-hidden="true"
              data-testid="circle-with-text-dot"
            ></span>
            <span class="whitespace-nowrap" data-testid="circle-with-text-label">{{ row[col.key]?.text }}</span>
          </div>
          } @case ('textWithChips') {
          <div class="flex flex-wrap whitespace-normal items-center gap-[8px]">
            @if (row[col.key]?.text) {
            <span class="whitespace-normal break-words">{{ row[col.key].text }}</span>
            }
            @if (row[col.key]?.listChips) {
            @for (chip of row[col.key].listChips; track $index) {
            <div
              class="flex items-center gap-x-[6px] px-[10px] py-[4px] rounded-full text-[11px] font-medium uppercase tracking-wider border border-transparent break-words leading-[18px]"
              [ngClass]="chip.chipClass || getStatusClasses(chip.chipText)" [style.backgroundColor]="chip.chipColor"
              [attr.title]="chip.chipTooltip || null">
              @if(chip.chipDotColor){
              <span class="w-[7px] h-[7px] rounded-full flex-shrink-0" [style.backgroundColor]="chip.chipDotColor"></span>
              }
              @if(chip.chipIcon){
              <i [class]="chip.chipIcon + ' text-[14px] flex items-center leading-none'"></i>
              }
              {{ chip.chipText }}
            </div>
            }}
          </div>
          } @case ('list') {
          <div class="items-center gap-2">
            @for (item of row[col.data]; track $index; let k = $index) {
            <div class="flex items-center gap-2 mb-1">
              <div
                class="w-4 h-4 rounded-full"
                [ngClass]="{
                  'bg-success': item.trafficLightType.toLowerCase() === 'green',
                  'bg-error': item.trafficLightType.toLowerCase() === 'red',
                  'bg-warning':
                    item.trafficLightType.toLowerCase() === 'orange',
                  'bg-gray': item.trafficLightType.toLowerCase() === 'gray'
                }"
              ></div>
              <span class="text-sm font-medium text-text-primary">
                {{ item.percentage }}%
              </span>
            </div>
            }
          </div>

          } @default {
          <span [ngClass]="col.contentClass ? col.contentClass : (row.visible === false ? 'text-[#9DA0A8] font-poppins text-sm font-medium' : 'text-text-primary font-poppins text-sm font-medium')" class="truncate block" appTruncateTooltip>
            {{ row[col.key] }}
          </span>

          } }
        </td>
        } @if (icon1 || icon2 || showToggle || showMenuThreeDots) {
        <td
          class="py-0 text-center sticky right-0 group-hover:!bg-[#E1E5FF] overflow-visible"
          [ngClass]="
            effectiveActionColumnClass
              ? effectiveActionColumnClass
              : actionColumnClass
              ? actionColumnClass
              : {
                  'bg-stepper-active-num': i % 2 === 0,
                  'bg-light': i % 2 === 1,
                  'shadow-left': showColumnShadow,
                  'w-auto': showHeaderFilter,
                  'w-[120px] px-4': !showHeaderFilter
                }
          "
        >
          <div [ngClass]="'flex items-center justify-center gap-2 relative ' + effectiveActionRowHeight">
            @if (icon1) {
            <span class="inline-flex" [title]="icon1TitleFor(row)">
            <button
              class="px-2 pt-1 leading-none"
              (click)="iconAction1.emit(row)"
              [disabled]="isIcon1Disabled(row)"
            >
              @if(row.icon1IsLoading){
              <div
                class="spinner w-5 h-5 border border-soft-gray border-t-transparent rounded-full"
              ></div>
              }@else{
              <i
                [class]="effectiveIcon1Class"
                [ngClass]="{
                  'text-text-secondary': isIcon1Disabled(row),
                  'text-text-primary': !isIcon1Disabled(row)
                }"
              >
              </i
              >}
            </button>
            </span>
            } @if (icon2) {
            <span class="inline-flex" [title]="icon2TitleFor(row)">
            <button
              class="px-2 pt-1 leading-none"
              (click)="iconAction2.emit(row)"
              [disabled]="isIcon2Disabled(row)"
            >
              <i
                [class]="effectiveIcon2Class"
                [ngClass]="{
                  'text-text-primary': !isIcon2Disabled(row),
                  'text-text-secondary': isIcon2Disabled(row)
                }"
              >
              </i>
            </button>
            </span>
            } @if (showToggle) {
            <button
              type="button"
              (click)="toggleRow(row)"
              [attr.aria-pressed]="row.toggleActive ? 'true' : 'false'"
              [disabled]="row.toggleIsDisabled || row.isToggleDisabled"
              class="relative inline-flex w-10 h-6 items-center rounded-full transition-colors duration-300 focus:outline-none"
              [ngClass]="{
                'bg-primary-g300': row.toggleActive,
                'bg-transparent border border-soft-gray opacity-50':
                  row.toggleIsDisabled,
                'bg-transparent border border-soft-gray': !row.toggleActive
              }"
            >
              <span
                class="absolute left-1 top-1 w-4 h-4 rounded-full shadow-sm transition-transform duration-300"
                [ngClass]="{
                  'translate-x-4 bg-light': row.toggleActive,
                  'translate-x-0 -translate-y-[1px] bg-gray': !row.toggleActive
                }"
              ></span>
            </button>
            } @if (showMenuThreeDots) { @if(row.visible) {
            <button
              class="p-2"
              title="Más opciones"
              (click)="toggleMenu(i, $event)"
              #menuButton
            >
              <i
                class="fi-rr-menu-dots-vertical text-text-primary text-base"
              ></i>
            </button>
            }@else{
            <button class="p-2" title="Desocultar" (click)="onToggleShow(row)">
              <i class="fi-rr-eye-crossed text-text-primary text-base"></i>
            </button>
            } }
          </div>
        </td>
        }
      </tr>
      } @for (empty of emptyRows; track $index; let j = $index) {
      <tr
        class="whitespace-nowrap odd:bg-stepper-active-num even:bg-light h-[52px]"
        [ngClass]="enableInternalScroll ? 'table w-full table-fixed' : ''"
      >
        @for (col of columns; track col.key) {
        <td class="px-4 py-2 text-sm align-middle"></td>
        } @if (icon1 || icon2 || showToggle) {
        <td
          class="px-4 py-2 text-center sticky right-0 z-10 align-middle"
          [ngClass]="
            actionColumnClass
              ? actionColumnClass
              : { 'shadow-left': showColumnShadow }
          "
        ></td>
        }
      </tr>
      }} @if (paginatedData.length === 0) {
      <tr [style.height.px]="emptyRows.length * 52">
        <td
          [attr.colspan]="
            columns.length + (icon1 || icon2 || showToggle ? 1 : 0)
          "
          class="text-center text-gray-500"
        >
          <div class="flex items-center justify-center h-full">
            {{ resultsNotFoundText }}
          </div>
        </td>
      </tr>
      }
    </tbody>
  </table>
</div>

@if (openMenuIndex !== null) {
<div
  class="fixed rounded-[24px] bg-white border border-soft-gray-outline shadow-xl z-[9999] p-3"
  [style.top.px]="menuPosition.top"
  [style.left.px]="menuPosition.left"
>
  <div
    class="absolute -top-2 right-6 w-4 h-4 bg-white border-l border-t border-soft-gray-outline transform rotate-45"
  ></div>

  <ul class="py-1 relative z-10">
    @if (showMenuAction('duplicate')) {
    <li>
      <button
        class="w-full text-left px-4 py-2 hover:bg-gray-100 flex items-center gap-3"
        (click)="onMenuAction('duplicate', paginatedData[openMenuIndex])"
      >
        <i class="fi-rr-duplicate text-base"></i>
        <span class="text-sm text-text-primary">Duplicar</span>
      </button>
    </li>
    }
    @if (showMenuAction('edit')) {
    <li>
      <button
        class="w-full text-left px-4 py-2 hover:bg-gray-100 flex items-center gap-3"
        (click)="onMenuAction('edit', paginatedData[openMenuIndex])"
      >
        <i class="fi-rr-edit text-base"></i>
        <span class="text-sm text-text-primary">Editar</span>
      </button>
    </li>
    }

    @if (showHideMenuItem(paginatedData[openMenuIndex])) {
    <li>
      <button
        class="w-full text-left px-4 py-2 hover:bg-gray-100 flex items-center gap-3"
        (click)="onMenuAction('hide', paginatedData[openMenuIndex])"
      >
        <i class="fi-rr-eye text-base"></i>
        <span class="text-sm text-text-primary">Ocultar</span>
      </button>
    </li>
    } @else if (showDeleteMenuItem(paginatedData[openMenuIndex])) {
    <li>
      <button
        class="w-full text-left px-4 py-2 hover:bg-gray-100 flex items-center gap-3"
        (click)="onMenuAction('delete', paginatedData[openMenuIndex])"
      >
        <i class="fi-rr-trash text-base"></i>
        <span class="text-sm text-text-primary">Eliminar</span>
      </button>
    </li>
    }
  </ul>
</div>
}
